import { login, logout, getInfo } from "@/api/login";
import { getToken, setToken, removeToken, setRefreshToken } from "@/utils/auth";

const user = {
  state: {
    token: getToken(),
    userInfo: {},
    name: "",
    avatar: "",
    roles: [],
    permissions: [],
    auditManager: {
      username: process.env.VUE_APP_AUDIT_MANAGER
    },
    mssageUnreadCount:0
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_USERINFO(state, data) {
      state.userInfo = data;
    },
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions;
    },
    SET_UNREADMSSAGE: (state, list) => {
      state.mssageUnreadCount = list;
    },
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo)
          .then(res => {
            console.log('Loginres', res)
            let resData = res.data;
            if (+resData.code === 0) {
              setToken(resData.result.accesstoken);
              setRefreshToken(resData.result.refreshtoken);
              commit("SET_TOKEN", resData.result.accesstoken);
              resolve();
            } else {
              reject(resData);
            }
          })
          .catch(error => {
            console.log('Loginerror', error)
            reject(error);
          });
      });
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo()
          .then(res => {
            const user = res.result;
            commit("SET_USERINFO", user);
            commit("SET_NAME", user.username);
            resolve(res);
          })
          .catch(error => {
            reject(error);
          });
      });
    },


    // 退出系统
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        commit("SET_TOKEN", "");
        commit("SET_ROLES", []);
        commit("SET_PERMISSIONS", []);
        setRefreshToken("");
        removeToken();
        resolve();
      });
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit("SET_TOKEN", "");
        removeToken();
        resolve();
      });
    }
  }
};

export default user;
